import { Autocomplete, TextField } from '@mui/material'
import React from 'react'

const AnalysisCode10 = () => {
    return (
        <>
            <Autocomplete
                sx={{ pb: 2 }}
                size='small'
                options={top100Films}
                renderInput={(params) => <TextField {...params} label="Analysis Code 10" />}
            />
        </>
    )
}

export default AnalysisCode10


const top100Films = [
    { label: 'The Shawshank Redemption', year: 1994 },
    { label: 'The Godfather', year: 1972 },
]